import React from "react";
import image1 from "../../Assets/Images/Renewable Energy (Solar _ Wind).png";
import image2 from "../../Assets/Images/Pharmaceuticals & Healthcare.png";
import image3 from "../../Assets/Images/Construction & Architecture.png";
import image4 from "../../Assets/Images/Food Processing & Packaging.png";
import image5 from "../../Assets/Images/Banking & Financial Services.png";
import image6 from "../../Assets/Images/Chemical, Plastic & Petrochemical Industries.png";
import image7 from "../../Assets/Images/Software Development & IT Services.png";
import image8 from "../../Assets/Images/Educational & Training Institutes.png";
import image9 from "../../Assets/Images/Call Centers & Customer Support.png";
import image10 from "../../Assets/Images/Agriculture & Agro-based Industries.png";
import image11 from "../../Assets/Images/Manufacturing & Industrial Production.png";
import image12 from "../../Assets/Images/Trading, Distribution & Logistics.png";
import image13 from "../../Assets/Images/Hotels, Restaurants & Hospitality.png";
import image14 from "../../Assets/Images/Electrical & Electronic Products.png";
import image15 from "../../Assets/Images/Transportation & Automotive.png";
import image16 from "../../Assets/Images/Telecommunications.png";
import image17 from "../../Assets/Images/Aerospace & Aviation.png";
import image18 from "../../Assets/Images/Environmental & Waste Management.png";
import image19 from "../../Assets/Images/Mining & Metals.png";
import image20 from "../../Assets/Images/Textile & Apparel.png";
import image21 from "../../Assets/Images/Media & Entertainment.png";
import image22 from "../../Assets/Images/Healthcare Equipment & Medical Devices.png";
import image23 from "../../Assets/Images/Consultancy & Professional Services.png";

const industries = [
  { name: "Renewable Energy (Solar / Wind)", image: image1 },
  { name: "Pharmaceuticals & Healthcare", image: image2 },
  { name: "Construction & Architecture", image: image3 },
  { name: "Food Processing & Packaging", image: image4 },
  { name: "Banking & Financial Services", image: image5 },
  { name: "Chemical, Plastic & Petrochemical Industries", image: image6 },
  { name: "Software Development & IT Services", image: image7 },
  { name: "Educational & Training Institutes", image: image8 },
  { name: "Call Centers & Customer Support", image: image9 },
  { name: "Agriculture & Agro-based Industries", image: image10 },
  { name: "Manufacturing & Industrial Production", image: image11 },
  { name: "Trading, Distribution & Logistics", image: image12 },
  { name: "Hotels, Restaurants & Hospitality", image: image13 },
  { name: "Electrical & Electronic Products", image: image14 },
  { name: "Transportation & Automotive", image: image15 },
  { name: "Telecommunications", image: image16 },
  { name: "Aerospace & Aviation", image: image17 },
  { name: "Environmental & Waste Management", image: image18 },
  { name: "Mining & Metals", image: image19 },
  { name: "Textile & Apparel", image: image20 },
  { name: "Media & Entertainment", image: image21 },
  { name: "Healthcare Equipment & Medical Devices", image: image22 },
  { name: "Consultancy & Professional Services", image: image23 },
];

const HomeServices = () => {
  return (
    <div className="industry-container">
      <h2 className="industry-title">Industry Sectors We Serve</h2>

      <div className="industry-grid">
        {industries.map((industry, index) => (
          <div key={index} className="industry-card">
            <div className="image-container">
              <img
                src={industry.image}
                alt={industry.name}
                className="industry-image"
              />
              <div className="overlay"></div>
            </div>
            <div className="industry-name">
              <h3>
                {industry.name}
              </h3>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default HomeServices;
